export default __webpack_public_path__ + "static/fasadritningar-28fdf735c94933657a4c7456f3986beb.pdf";